import { Box } from "@mui/material"
import { TabContext, TabList, TabPanel } from "@mui/lab"
import { useState } from "react"
import { useSelector } from "react-redux"
import { StyledTab } from "./Atom"
import AdvisorListTab from "./GroupUserTabs/Advisor"
import CSMListTab from "./GroupUserTabs/CSM"
import OfficeManagerListTabs from "./GroupUserTabs/OfficeManagers"
import GroupAdminListTab from "./GroupUserTabs/GroupAdmins"

const GroupDetails = () => {
  const [value, setValue] = useState("1")

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue)
  }

  const groupInfo = useSelector((state: any) => {
    return state.groupProfile.groupInfo
  })

  return (
    <Box
      sx={{
        "& .MuiTabPanel-root": {
          padding: "0px",
        },
        display: "flex",
        height: "100%",
        flexDirection: "column",
        "& .css-14ctql5 .MuiTabPanel-root": {
          padding: 0,
          height: "10% ",
        },
      }}
    >
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            sx={{
              backgroundColor: "#F7F7F7",
              "& .css-80qg1k-MuiButtonBase-root-MuiTab-root.Mui-selected": {
                alignItems: "flex-start",
              },
              "& .css-80qg1k-MuiButtonBase-root-MuiTab-root": {
                alignItems: "flex-start",
              },
            }}
            aria-label="lab API tabs example"
            TabIndicatorProps={{
              sx: {
                maxWidth: "34px",
                height: "4px",
              },
            }}
          >
            <StyledTab label="Group Admin" value="1" />
            <StyledTab label="CSM" value="2" />
            <StyledTab label="Advisor" value="3" />
            <StyledTab label="Office/Regional Manager" value="4" />
          </TabList>
        </Box>
        <TabPanel value="1" sx={{ height: "100%" }}>
          <GroupAdminListTab group_sk={groupInfo?.group_sk} />
        </TabPanel>
        <TabPanel value="2" sx={{ height: "100%" }}>
          <CSMListTab group_sk={groupInfo?.group_sk} />
        </TabPanel>
        <TabPanel value="3">
          <AdvisorListTab group_sk={groupInfo?.group_sk} />
        </TabPanel>
        <TabPanel value="4">
          <OfficeManagerListTabs group_sk={groupInfo?.group_sk} />
        </TabPanel>
      </TabContext>
    </Box>
  )
}
export default GroupDetails
